<template>
  <div>
    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0;"
      >
        <el-table-column
          label="体验营类型"
          align="center"
          min-width="10%"
          prop="type_value"
        >
        </el-table-column>

        <el-table-column
          label="体验营ID"
          align="center"
          min-width="9%"
          prop="course_id"
        >
        </el-table-column>

        <el-table-column
            label="当前关联体验营名称"
            align="center"
            min-width="27%"
            prop="title"
        >
        </el-table-column>

        <el-table-column
            label="开课时间"
            align="center"
            min-width="18%"
            prop="begin_time"
        >
        </el-table-column>

        <el-table-column label="经营工具id设置" align="center" min-width="13%">
          <template slot-scope="{ row }">
            <span>
              <el-button
                  size="medium"
                  type="primary"
                  style="margin-left: 5px;"
                  @click="
                  course_dy_id = row.course_dy_id;
                  relation.chooseOrgVisible = true;
                  getRelationExpData();
                "
              >设置 ({{ row.tool_num }})
              </el-button>
            </span>
          </template>
        </el-table-column>

        <el-table-column label="关联体验营" align="center" min-width="13%">
          <template slot-scope="{ row }">
            <span v-if="row.course_dy_id > 0">
              <el-button
                  size="medium"
                  type="primary"
                  style="margin-left: 5px;"
                  @click="
                  course_dy_id = row.course_dy_id;
                  course_camp_type_id = row.id;
                  course_id = row.course_id;
                  type_key = row.type_key;
                  is_next_type = 1;
                  add_relation.chooseOrgVisible = true;
                  addExpSearchData();">更新
              </el-button>
            </span>
            <span v-if="row.course_dy_id == 0">
              <el-button
                  size="medium"
                  type="primary"
                  style="margin-left: 5px;"
                  @click="
                  course_dy_id = row.course_dy_id;
                  course_camp_type_id = row.id;
                  course_id = row.course_id;
                  type_key = row.type_key;
                  add_relation.chooseOrgVisible = true;
                  addExpSearchData();">关联
              </el-button>
            </span>
          </template>
        </el-table-column>

        <el-table-column label="图片" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px;" alt="" />
          </template>
        </el-table-column>

      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <el-dialog
        title="设置工具列表"
        :visible.sync="relation.chooseOrgVisible"
        :close-on-click-modal="true"
        :before-close="addRelationEditFormOnClose"
        width="75%"
    >
      <el-form>
        <el-form-item>
          <el-button
              type="primary"
              size="mini"
              @click="add_tool_relation.chooseOrgVisible = true;">添加工具ID
          </el-button>
        </el-form-item>
      </el-form>
      <!--列表-->
      <el-table
          border
          :data="relation.result.data"
          highlight-current-row
          v-loading="relation.listLoading1"
          style="..."
      >
        <el-table-column prop="dy_tool_id" label="工具ID" align="center" min-width="25%"></el-table-column>
        <el-table-column prop="tool_title" label="工具名称" align="center" min-width="35%"></el-table-column>

        <el-table-column label="操作" align="center" min-width="15%">
          <template slot-scope="{ row }">&nbsp;
            <span>
              <el-button type="primary" size="mini" @click="deleteTool(row)">
                删除
              </el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
        title="添加工具ID"
        :visible.sync="add_tool_relation.chooseOrgVisible"
        width="35%">
      <el-form :model="add_tool_relation.query">
        <el-form-item label="工具ID">
          <el-input placeholder="请输入工具ID" v-model="add_tool_relation.query.dy_tool_id"></el-input>
        </el-form-item>
        <el-form-item label="工具名称">
          <el-input placeholder="请输入工具名称" v-model="add_tool_relation.query.tool_title"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="add_tool_relation.chooseOrgVisible = false">取 消</el-button>
        <el-button type="primary" @click="addToolRelation()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
        title="选择课程"
        :visible.sync="add_relation.chooseOrgVisible"
        :close-on-click-modal="true"
        :before-close="addExpEditFormOnClose"
        width="75%"
    >
      <el-form :inline="true" :model="add_relation.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
              size="mini"
              v-model="add_relation.query.search"
              placeholder="请输入标题"
              clearable
              @blur="addExpSearchData()"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="addExpSearchData()">
            查询课程
          </el-button>
        </el-form-item>
      </el-form>

      <!--列表-->
      <el-table
          border
          :data="add_relation.result.data"
          highlight-current-row
          v-loading="add_relation.listLoading1"
          style="..."
      >
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column
            prop="title"
            label="标题"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="begin_time"
            label="开课时间"
            align="center"
        >
        </el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px;" alt="" />
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" @click="addSelectExperience(row)">
              确定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          @current-change="addExpSearchData"
          :current-page.sync="add_relation.query.page"
          :page-size="add_relation.query.limit"
          layout="total, prev, pager, next, jumper"
          :total="add_relation.result.total"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import {
  getList,  //列表
  syncCourse,  //关联体验营
  screenExperienceList,  //筛选体验营列表
  getCourseToolList,    //课程工具列表
  addTool,    //添加工具
  delTool,   //删除工具
} from "@/api/dyClue";

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 30,
      },

      course_dy_id: 0,
      course_camp_type_id: 0,
      course_id: 0,
      type_key: 0,

      is_next_type: 0,

      add_tool_relation: {
        reason: '',
        chooseOrgVisible: false,
        formLabelWidth: '120px',
        query: {
          dy_tool_id: '',
          tool_title: '',
          course_dy_id: 0
        },
      },

      relation: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          page: 1,
          course_dy_id: 0,
        },
        result: {
          total: 0,
          data: [],
        },
      },

      add_relation: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          search: "",
          page: 1,
          limit: 5,
          type_key: 0
        },
        result: {
          total: 0,
          data: [],
        },
      },

      relation_query: {
        course_dy_id: 0,
        course_camp_type_id: 0,
        course_id: 0,
      }
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    addToolRelation() {
      if (this.add_tool_relation.query.dy_tool_id == '') {
        this.$message({
          message: "工具id不能为空!",
          type: "error",
        });
        return false;
      }
      if (this.add_tool_relation.query.tool_title == '') {
        this.$message({
          message: "工具名称不能为空!",
          type: "error",
        });
        return false;
      }
      this.add_tool_relation.query.course_dy_id = this.course_dy_id;
      addTool(this.add_tool_relation.query).then((response) => {
        if (response.status == 2000) {
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
        }
        this.add_tool_relation.query.dy_tool_id = '';
        this.add_tool_relation.query.tool_title = '';
        this.add_tool_relation.query.course_dy_id = 0;
        this.getRelationExpData();
      });
      this.add_tool_relation.chooseOrgVisible = false;
    },

    // 弹窗关闭
    addRelationEditFormOnClose() {
      this.relation.query.page = 1;
      this.relation.result = {
        total: 0,
        data: [],
      };
      this.relation.chooseOrgVisible = false;
      this.getList()
    },

    getRelationExpData(){
      this.relation.query.course_dy_id = this.course_dy_id;
      this.relation.listLoading1 = true;
      getCourseToolList(this.relation.query).then((response) => {
        this.relation.result.data = response.data.list;
        this.relation.result.total = response.data.total;
        this.relation.listLoading1 = false;
      });
    },

    deleteTool(row) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delTool({
          course_dy_clue_id: row.course_dy_clue_id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getRelationExpData();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          }
        });
      });
    },

    // 弹窗关闭
    addExpEditFormOnClose() {
      this.add_relation.query.page = 1;
      this.add_relation.query.search = "";
      this.add_relation.result = {
        total: 0,
        data: [],
      };
      this.add_relation.chooseOrgVisible = false;
    },


    addSelectExperience(row) {
      this.relation_query.course_dy_id = this.course_dy_id;
      this.relation_query.course_camp_type_id = this.course_camp_type_id;
      this.relation_query.course_id = row.id;
      console.log(this.relation_query)
      syncCourse(this.relation_query).then((response) => {
        if (response.status == 2000) {
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
        }
        this.getList();
      });
      this.add_relation.chooseOrgVisible = false;
    },

    // 查询方法
    addExpSearchData() {
      var courseDyId = this.course_dy_id;
      var isNextType = this.is_next_type;
      this.add_relation.query.type_key = this.type_key;
      console.log(courseDyId)
      // eslint-disable-next-line no-empty
      if ((courseDyId > 0) && (isNextType == 1)) {
        this.is_next_type = 0;
        this.add_relation.chooseOrgVisible = false
        this.$confirm('当前类型已关联体验营，确定更新？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.add_relation.chooseOrgVisible = true
          this.add_relation.listLoading1 = true;
          screenExperienceList(this.add_relation.query).then((response) => {
            this.add_relation.result.data = response.data.list;
            this.add_relation.result.total = response.data.total;
            this.add_relation.listLoading1 = false;
          });
        }).catch(() => {
          //几点取消的提示
        });
      } else {
        this.add_relation.listLoading1 = true;
        screenExperienceList(this.add_relation.query).then((response) => {
          this.add_relation.result.data = response.data.list;
          this.add_relation.result.total = response.data.total;
          this.add_relation.listLoading1 = false;
        });
      }
    },

    getList() {
      this.loading = true;
      getList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },
  },
  mounted() {},
};
</script>
